import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';
import Loading from 'components/general/Loading';
import { getMe } from 'api/auth';

const baseUrl = `${process.env.REACT_APP_API_URL}/v1`;

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');

  useEffect(async () => {
    try {
      const { data } = await getMe();
      setCurrentUser(camelcaseKeys(data));
      setLoading(false);
    } catch (error) {
      console.error(error);

      if (!token) {
        localStorage.removeItem('token');
      }
    }
  }, []);

  const value = {
    currentUser,
    loading,
    setCurrentUser,
  };

  return (
    <AuthContext.Provider value={value}>
      {loading && token ? <Loading /> : children}
    </AuthContext.Provider>
  );
}
